import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { cn } from '@/lib/utils'

import { siteConfig } from '@/constants/site'

interface LogoProps {
    className?: string
}

export const Logo: FC<LogoProps> = ({ className }): ReactNode => {
    return (
        <Link
            href='/'
            aria-label={`${siteConfig.name} home`}
            className={cn(
                'inline-flex items-baseline font-heading text-[1.75rem] font-semibold leading-none tracking-tight text-foreground rounded-sm focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-ring',
                className
            )}
        >
            {siteConfig.name}
            <span className='text-brand'>.</span>
        </Link>
    )
}
